.link {
  display: inline-flex;
}

.nameLink {
  > * {
    transition: color 200ms ease;
  }

  &:hover,
  &:focus,
  &:active {
    > * {
      color: var(--ixf-text-tone-md);
    }
  }
}
